//서버타입이 나오지 않아서 임시 서버타입. 서버타입 나오면 제거 예정
interface CategoryTreeDto {
  id: number;
  name: number;
  parentId: null;
  subCategories: { id: number; name: number; parentId: number }[];
}
export interface CategoryTreeResponseDto {
  categories: CategoryTreeDto[];
}
export interface CategoryTreeRequestDto {
  isExhibition?: 0 | 1;
}

export class CategoryTreeItemV2 {
  id: number;
  name: number;
  subCategories: { id: number; name: number; parentId: number }[];
  constructor(tree: CategoryTreeDto) {
    this.id = tree.id;
    this.name = tree.name;
    this.subCategories = tree.subCategories;
  }
}

export type CategoryTreeOptionV2 = {
  isExhibition?: boolean;
};

export class CategoryTreeRequestOption implements CategoryTreeRequestDto {
  isExhibition?: 0 | 1;
  constructor(option: CategoryTreeOptionV2) {
    this.isExhibition = option.isExhibition === undefined ? option.isExhibition : option.isExhibition ? 1 : 0;
  }
}
